import {
  DownOutlined,
  KeyOutlined,
  LogoutOutlined,
  UploadOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Upload,
  message,
} from "antd";
import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from "react";
// import Logo from "../../assets/images/logo-dark.svg";
import NotificationImg from "../../assets/images/Logo.png";
import notfound from "../../assets/images/not_found.png";
import { AuthContext } from "../../context/AuthContext";
import useRequest from "../../hooks/useRequest";
import Prouser from "../../assets/images/user.png";
import Notification from "../../assets/images/notification-bell.svg";
import { Severty, ShowToast } from "../../helper/toast";
import apiPath from "../../constants/apiPath"; 

import {
  changeEmail,
  changePassword,
  getAdminNotification,
  getProfile,
  updateProfile,
} from "../../helper/API/API";
import useApi from "../../hooks/useApi";
import callApi from "../../helper/API/CallApi";
import { uploadFileToS3 } from "../../helper/uploadImage";

const { confirm } = Modal;

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name: sectionHeading, onPress, setToggle }) {
  const [visible, setVisible] = useState(false);
    const Navigate = useNavigate();
  const [OTPVisible, setOTPVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [profile, setProfile] = useState({});
  const { request } = useRequest();

  const [profileVisible, setProfileVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [emailVisible, setEmailVisible] = useState(false);

  const [appSettingVisible, setAppSettingVisible] = useState(false);
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [notification, setNotification] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const profileData = useApi({
    callback: getProfile,
    dependencies: [profileVisible, refresh],
    onSuccess: (data) => {
      setProfile(data);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    callApi({
      callback: getAdminNotification,
      payload: { limit: 3, sortField: "createdAt", sort: "desc" },
      onSuccess: ({ message, data }) => {
        setNotification(data.list);
        setNotificationCount(data?.totalDocs);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
      },
    });
  }, [refresh]);

  const handleNotiNavigate = (noti) => {
    console.log(noti, "useFor...");

    if (noti.use_for === "QUOTE") {
      navigate("/quotation-request");
    } else if (noti.use_for === "REPORT") {
      navigate("/reports");
    } else if (noti.use_for === "USER_SIGNUP") {
      navigate("/customer");
    } else if (noti.use_for === "VENDOR_SIGNUP") {
      navigate("/service-provider");
    }

    if (noti?.use_for && !noti?.is_read) {
      request({
        url: `${apiPath.notification}/read/${noti?._id}`,
        method: "POST",
        onSuccess: ({ data }) => {
          ShowToast("Notification Read Successfully", Severty.SUCCESS);
        },
        onError: (err) => {
          console.log(err);
        },
      });
    }
  };
  const notificationitems = [
    {
      label: (
        <div className="notification_top">
          <div className="notification-head">
            <h5>Notifications</h5>
          </div>
          <div className="notification-inner">
            {notification?.length ? (
              notification?.map((item) => (
                <div
                  key={item._id}
                  className="single-notification"
                  onClick={() => handleNotiNavigate(item)}
                >
                  <div className="notification-img">
                    <img src={NotificationImg} />
                  </div>
                  <div className="notification-cont">
                    <p>
                      <span>{item.title ? item.title : ""}</span>
                      <p>{item.body ? item.body : ""}</p>
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <span>No Notification</span>
            )}
          </div>
          {notification?.length ? (
            <div className="viewAll_notification">
              <Button
                onClick={() => navigate("/notification")}
                className="btnStyle btn_primary"
              >
                View All
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const items = [
    {
      label: "Edit Profile",
      key: "1",
      icon: <UserOutlined />,
      danger: true,
    },
    {
      label: "Change Password",
      key: "2",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: "Change Email",
      key: "4",
      icon: <KeyOutlined />,
      danger: true,
    },
    {
      label: "Logout",
      key: "3",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const handleMenuClick = (e) => {
    setIsOpen(false);
    if (e.key == 2) {
      setVisible(true);
    }
    if (e.key == 1) {
      setProfileVisible(true);
    }
    if (e.key == 4) {
      setEmailVisible(true);
    }
    if (e.key == 3) {
      setIsLogoutModalVisible(true);
    }
  };
  const handleOk = () => {
    logout(0);
    setIsLogoutModalVisible(false);
  };

  const handleCancel = () => {
    setIsLogoutModalVisible(false);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleChangePassword = () => {
    form
      .validateFields()
      .then((values) => {
        // form.resetFields();
        onChangePassword(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const handleChangeEmail = () => {
    form
      .validateFields()
      .then((values) => {
        // form.resetFields();
        onChangeEmail(values);
        setEmailVisible(false); // Close the modal after the email is changed
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const onChangeEmail = (values) => {
    const { newEmail, email } = values;
    const payload = {};

    if (!email || !newEmail)
      return ShowToast("Please enter password ", Severty.ERROR);

    if (email === newEmail)
      return ShowToast("Old and New Email can't be same", Severty.ERROR);
    setLoading(true);
    payload.newEmail = newEmail;
    payload.email = email;

    callApi({
      callback: changeEmail,
      payload: payload,
      onSuccess: ({ message }) => {
        setLoading(false);
        ShowToast(message, Severty.SUCCESS);
        setOTPVisible(true);
      },
      onError: ({ err }) => {
        setLoading(false);
        ShowToast(err, Severty.ERROR);
      },
    });
  };
  const onChangePassword = (values) => {
    const { old_password, new_password } = values;
    const payload = {};
    if (old_password === new_password)
      return ShowToast("Please do not enter same password ", Severty.ERROR);
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);

    if (old_password === new_password)
      return ShowToast("Old and New password can't be same", Severty.ERROR);
    setLoading(true);
    payload.password = new_password;
    payload.oldPassword = old_password;

    callApi({
      callback: changePassword,
      payload: payload,
      onSuccess: ({ message }) => {
        setLoading(false);
        ShowToast(message, Severty.SUCCESS);
        logout(0);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err.split(",")[1], Severty.ERROR);
      },
    });
  };
  const handleVerifyOTP = () => {
    form
      .validateFields()
      .then((values) => {
        // form.resetFields();
        onVerifyOTP(values);
        setOTPVisible(false); // Close the modal after the email is changed
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const onVerifyOTP = (values) => {
    const { newEmail, email } = values;
    const payload = {};

    if (!email || !newEmail)
      return ShowToast("Please enter password ", Severty.ERROR);

    if (email === newEmail)
      return ShowToast("Old and New Email can't be same", Severty.ERROR);
    setLoading(true);
    payload.newEmail = newEmail;
    payload.email = email;

    callApi({
      callback: changeEmail,
      payload: payload,
      onSuccess: ({ message }) => {
        setLoading(false);
        ShowToast(message, Severty.SUCCESS);
        setOTPVisible(true);
      },
      onError: ({ err }) => {
        setLoading(false);
        ShowToast(err, Severty.ERROR);
      },
    });
  };
  return (
    <>
      <Row gutter={[24, 0]} className="justify-content-between mx-0">
        <Col
          span={24}
          xs={24}
          md={24}
          lg={12}
          sm={24}
          className="SectionMain px-0 py-2  left-header"
        >
          {/* <Button
            type="link"
            className="sidebar-toggler ps-0 d-none d-lg-block"
            onClick={() => setToggle()}
          >
            {toggler}
          </Button> */}

        </Col>
        <Col span={24} xs={24} sm={24} lg={12} className="header-control px-0">
          <Button
            type="link"
            className="sidebar-toggler ps-0 d-lg-none"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          {/* <div className="header-right-btns">
              <Button   onClick={() => Navigate("/personal-info")}>Profile</Button>
              <Button   onClick={() => Navigate("/login")}>Logout</Button>
          </div> */}
          {/* <div className="notificationDropdownMain">
            <div className="notification-header d-lg-block">
              <Dropdown
                menu={{ items: notificationitems }}
                trigger={["click"]}
                className="notification-box"
              >
                <Button>
                  <img src={Notification} />
                  <span className="active_notification active_notification-999 ">
                    {notificationCount ?? 0}
                  </span>
                </Button>
              </Dropdown>
            </div>
          </div>
          <div className="profileDropdownMain">
            <Dropdown
              open={isOpen}
              onOpenChange={(open) => setIsOpen(open)}
              className="edit-box"
              menu={menuProps}
              trigger={["click"]}
            >
              <Button className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open">
                <div className=" d-flex align-items-center gap-2">
                  <div className="userImg">
                    <Image
                      src={profile ? profile.profilePic : notfound}
                      preview={false}
                    />
                  </div>
                  <div className="d-none d-xl-block">
                    <div className="userName">
                      {profile ? profile?.name : "Administrator"}
                      <DownOutlined />
                    </div>
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div> */}
        </Col>
      </Row>
      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={profile}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      <Modal
        className="tab_modal"
        open={visible}
        title="Change password"
        okText="Ok"
        onCancel={() => {
          setVisible(false);
        }}
        onOk={handleChangePassword}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Password"
            name="old_password"
            hasFeedback
            rules={[
              { required: true, message: "Please enter the old password!" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            hasFeedback
            rules={[
              { required: true, message: "Please enter the new password!" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirm_new_password"
            dependencies={["new_password"]}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the confirm password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Passwords that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className="tab_modal"
        open={emailVisible}
        title="Change Email"
        okText="Ok"
        onCancel={() => {
          setEmailVisible(false);
        }}
        onOk={handleChangeEmail} // Add a function to handle email change logic
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Email"
            name="email"
            rules={[
              { required: true, message: "Please enter the old email!" },
              { type: "email", message: "Please enter a valid old email address" },
            ]}
          >
            <Input placeholder="Enter your old email" />
          </Form.Item>
          <Form.Item
            label="New Email"
            name="newEmail"
            rules={[
              { required: true, message: "Please enter the new email!" },
              { type: "email", message: "Please enter a valid new email address" },
            ]}
          >
            <Input placeholder="Enter your new email" />
          </Form.Item>
          <Form.Item
            label="Confirm New Email"
            name="confirm_new_email"
            dependencies={["newEmail"]}
            rules={[
              { required: true, message: "Please confirm your new email!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newEmail") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The emails that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input placeholder="Re-enter your new email" />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        className="tab_modal"
        open={OTPVisible}
        title="Change Email"
        okText="Ok"
        onCancel={() => {
          setOTPVisible(false);
        }}
        onOk={handleVerifyOTP} // Add a function to handle email change logic
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Email OTP"
            name="OTP"
            rules={[{ required: true, message: "Please enter OTP!" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Logout Confirmation"
        open={isLogoutModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Logout"
        cancelText="Cancel"
        className="main-confermation-model-logout77"
      >
        <h5>Logout</h5>
        <p>Are you sure you want to logout?</p>
      </Modal>
    </>
  );
}

export default Header;

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const [image, setImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    "image/gif",
  ];

  const handleChange = async (event) => {
    const { file } = event;
    setFile([file]);
    uploadFileToS3({ file, dirName: "wager/profile" })
      .then((data) => {
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data.Location,
          thumbUrl: data.Location,
        };
        setImage(data.Location);
        setFile([fileData]);
      })
      .catch((err) => console.error(err));
  };

  const beforeUpload = (file) => {
    if (FileType.includes(file.type)) {
    } else {
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!data || !form) return;
    form.setFieldsValue({ ...data });
    // setFile([data.image]);
    console.log(data, "data");
    if (data.profilePic) {
      setImage([data.profilePic]);
      setFile([data.profilePic]);
    } else {
      setImage([notfound]);
    }
  }, [data]);

  const onEditProfile = (values) => {
    const { email, name } = values;
    console.log(values, "values");
    if (file.length <= 0)
      return ShowToast("Please select the profile Image ", Severty.ERROR);
    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.profilePic = file.length > 0 ? file[0].url : null;
    console.log(payload, "payload");
    callApi({
      callback: updateProfile,
      payload: payload,
      onSuccess: ({ message }) => {
        setLoading(false);
        ShowToast(message, Severty.SUCCESS);
        hide();
        refresh();
      },
      onError: ({ err }) => {
        setLoading(false);
        ShowToast(err, Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      className="tab_modal"
      open={show}
      title={`${data ? "Edit Profile" : ""}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
              normalize={(value) => value.trimStart()}
              rules={[
                { required: true, message: "Please enter the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                { required: true, message: "Please enter the email!" },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Email Address" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={beforeUpload}
              customRequest={handleChange}
              onRemove={(e) => setFile([])}
              fileList={file}
            >
              {file.length > 0 ? null : (
                <Button icon={<UploadOutlined />}>Upload</Button>
              )}
            </Upload>

            <div className="mt-3">
              {" "}
              <Image src={image}></Image>{" "}
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
